export default {
	init() {
		/// Phone number masking http://igorescobar.github.io/jQuery-Mask-Plugin/docs.html
		$('.single-imf #phone').mask('(000) 000-0000');

		//Submit New IMF
		var imfSubmitCount = 0;
		$('form.imf-form').on('submit',function (event) {
			//Display spinner
			$('#submit_button').css('width','160px');
			$('#loading-spinner').removeClass('hidden');
			$('#loading-spinner').addClass('inline-block');	
			
			//grechaptcha
			event.preventDefault();
			var that = this;//set that variable so it will be available in next function
			imfSubmitCount++;
			if (imfSubmitCount <=1 ) {//Prevent double-click
				if( $('#recaptchaResponse').length) {
					grecaptcha.ready(function () { 
						grecaptcha.execute('6Lerg-kUAAAAAOKHCBzpYMKugpr8WKG6fNPdhy6K', {action: 'register'}).then(function(token) {
							var recaptchaResponse = document.getElementById('recaptchaResponse'); 
							recaptchaResponse.value = token;
							
							$(that).off("submit"); // to guarantee the function won't be invoked
							that.submit();
						});
					});
				}
			}

			//Google Tag Manager Tracking
			var campaignVar = $(".imf-campaign").data('campaign');
			dataLayer.push({ 'sfCampaign': campaignVar, 'newVisitor': true, 'event': 'imfSubmit' });
		});

		//Submit Returning IMF
		$(document).on('submit', 'form.imf-returning-form', function () {
			$('#loading-spinner').removeClass('hidden');
			$('#loading-spinner').addClass('inline-block');
			
			//Google Tag Manager Tracking
			var campaignVar = $(".imf-campaign").data('campaign');
			dataLayer.push({ 'sfCampaign': campaignVar, 'newVisitor': false, 'event': 'imfSubmit' });
		});

		//Automatic download
		//If the download button is on the page, pull the url and auto download
		if ($(".imf-download-btn")[0]){
			document.location.href = $(".imf-download-btn").data('download');
		}
	}
}